import { useState } from 'react';
import { MdCancel } from 'react-icons/md';
import { AiOutlineLoading, AiOutlineClose } from 'react-icons/ai';
import ClientService from '../../../rest/clientService';
import ModalPortal from '../../../components/lib/modalPortal';

export const CancelOrderModal = ({ order, isOpen, onClose, onConfirm, loading }) => {
    const [motive, setMotive] = useState("");
    const [pin, setPin] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async () => {
        if (!motive) return setError("Selecione um motivo.");
        try {
            const isValid = await ClientService.checkAdminOperationalPin(pin);
            if (isValid) { setError(""); onConfirm(order, motive); } 
            else setError("PIN incorreto.");
        } catch (e) { setError("Erro de validação."); }
    };

    if (!isOpen) return null;

    return (
        <ModalPortal>
            <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
                <div className="bg-white rounded-xl shadow-2xl p-6 w-full max-w-md animate-in zoom-in duration-200">
                    <div className="flex justify-between items-center mb-6">
                        <h3 className="text-lg font-bold text-gray-800">Cancelar Pedido #{order?.order_id}</h3>
                        <button onClick={onClose}><AiOutlineClose /></button>
                    </div>
                    <label className="block text-xs font-bold text-gray-500 mb-1 uppercase">Motivo</label>
                    <select className="w-full p-3 border rounded-lg mb-4 bg-white" onChange={(e) => setMotive(e.target.value)}>
                        <option value="">Selecione...</option>
                        <option value="Produto fora de estoque.">Produto fora de estoque.</option>
                        <option value="Erro no pagamento.">Erro no pagamento.</option>
                        <option value="Pedido incorreto.">Pedido incorreto.</option>
                        <option value="Outro.">Outro...</option>
                    </select>
                    <label className="block text-xs font-bold text-gray-500 mb-1 uppercase">PIN Administrativo</label>
                    <input type="password" placeholder="****" className="w-full p-3 border rounded-lg mb-2" value={pin} onChange={(e) => setPin(e.target.value)} />
                    {error && <p className="text-red-500 text-xs mb-4 font-bold">{error}</p>}
                    <button onClick={handleSubmit} disabled={loading} className="w-full bg-red-500 text-white font-bold py-3 rounded-lg flex justify-center items-center gap-2">
                        {loading ? <AiOutlineLoading className="animate-spin" /> : <><MdCancel /> Confirmar Cancelamento</>}
                    </button>
                </div>
            </div>
        </ModalPortal>
    );
};